import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import * as WebAuthnJSON from '@github/webauthn-json/browser-ponyfill';
import Store from '@ember-data/store';
import { type PasskeysLoginModel } from 'donor-elf-web/routes/funds/fund/more/passkeys/login';

export default class PasskeysLoginController extends Controller {
  @service declare store: Store;

  model!: PasskeysLoginModel;

  @action
  async login() {
    let options = WebAuthnJSON.parseRequestOptionsFromJSON({
      publicKey: this.model.authOption.options,
    });
    let response = await WebAuthnJSON.get(options);
    let verification = this.store.createRecord('webauthn/auth-verification', {
      credential: response,
    });
    try {
      await verification.save();
      alert('It worked!');
    } catch (error) {
      alert('there was an error!');
      // this.error =  error;
    }
  }
}
